module.exports = __webpack_public_path__ + "reason-to-book.svg?f4678c5a47ada7018a05b9bdcc475e2f";